import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "billingModel",
    "onsiteFields",
    "onsiteDailyRate",
    "onsiteMaxDays",
  ];

  connect() {
    this.update();
  }

  update() {
    const billingModel = this.billingModelTarget.value;
    const needsOnsite = billingModel === "remote_onsite_daily_rates";

    this.onsiteFieldsTargets.forEach((el) => {
      el.classList.toggle("d-none", !needsOnsite);
    });

    this.onsiteDailyRateTarget.toggleAttribute("disabled", !needsOnsite);
    this.onsiteMaxDaysTarget.toggleAttribute("disabled", !needsOnsite);

    this.onsiteDailyRateTarget.toggleAttribute("required", needsOnsite);
    this.onsiteMaxDaysTarget.toggleAttribute("required", needsOnsite);
  }
}
